import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';
import pure from 'recompose/pure';
import { translate } from "admin-on-rest";

const TextField = ({ source, record = {}, elStyle, translate }) => {
    let originalTimeElapse = get(record, source);
    
    const days = Math.floor(originalTimeElapse / (3600 * 24));
    originalTimeElapse -= days * 3600 * 24;
    const hrs = Math.floor(originalTimeElapse / 3600);
    originalTimeElapse -= hrs * 3600;
    const mnts = Math.floor(originalTimeElapse / 60);
    originalTimeElapse -= mnts * 60;
    
    if(!originalTimeElapse){
        const unknownUptime = translate("resources.devices.fields.unknownUptime");
        return <span style={elStyle}>{unknownUptime}</span>;
    }

    return <span style={elStyle}>Up {days === 1 ? days + ' day' : days + ' days'} {hrs < 10 ? '0' + hrs : hrs}:{mnts < 10 ? '0' + mnts : mnts}:{originalTimeElapse < 10 ? '0' + originalTimeElapse : originalTimeElapse}</span>;
};

TextField.propTypes = {
    addLabel: PropTypes.bool,
    elStyle: PropTypes.object,
    label: PropTypes.string,
    record: PropTypes.object,
    source: PropTypes.string.isRequired,
};

const PureTextField = pure(TextField);

PureTextField.defaultProps = {
    addLabel: true,
};

export default translate(PureTextField);




// WEBPACK FOOTER //
// ./src/containers/CRM/Devices/DeviceTextField.js